import { BookingToolRoot, getBookingToolUrlParams } from '@susu/booking-tool-v2'
import { resolveEnv } from './env'

/**
 * Reads URL search params to enable direct deep-links into specific screens.
 * Supports legacy kebab-case keys from the old booking tool
 * (e.g. `?screen=timeslot&booking-id=…`).
 */
const App = () => {
  const {
    language,
    location,
    locationId,
    locationCode,
    employeeId,
    bookingId,
    serviceId,
    userId,
    signature,
    initialScreen,
  } = getBookingToolUrlParams()
  const env = resolveEnv()

  const handleClose = () => {
    // In standalone mode there's no parent to notify — navigate back or close tab
    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.close()
    }
  }

  /*
   * `h-dvh`, not `h-screen`: iOS Safari puts its toolbar at the bottom and
   * `100vh` measures the viewport as if it were not there, so the footer pinned
   * to the bottom of this column sat partly underneath it — the reschedule
   * button most visibly. `100dvh` tracks the visible viewport. Supported since
   * Safari 15.4 / Chrome 108.
   */
  return (
    <div className="h-dvh overflow-hidden bg-[var(--color-surface-surface,#fff)] flex flex-col">
      <BookingToolRoot
        env={env}
        language={language}
        location={location}
        locationId={locationId}
        locationCode={locationCode}
        employeeId={employeeId}
        bookingId={bookingId}
        serviceId={serviceId}
        userId={userId}
        signature={signature}
        initialScreen={initialScreen}
        isStandalone
        onClose={handleClose}
      />
    </div>
  )
}

export default App
